import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { QueryClient } from '@tanstack/react-query';

const isServer = typeof window === 'undefined';
export const persister = createAsyncStoragePersister({
  storage: isServer ? undefined : window.localStorage,
});

// remove queryMounted information on first render to enable refetch when refreshing the page
const storage = !isServer ? localStorage : undefined;
storage?.removeItem('queryMounted');

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount(query) {
        const queryMounted: Record<string, boolean> = JSON.parse(
          storage?.getItem('queryMounted') ?? '{}'
        );

        // on first mount invalidate the query (refetch the data)
        if (!queryMounted[query.queryHash]) {
          // Mark the query as mounted
          storage?.setItem(
            'queryMounted',
            JSON.stringify({ ...queryMounted, [query.queryHash]: true })
          );

          query.invalidate();
        }

        return true;
      },
      // gcTime: 1000 * 60 * 60 * 24, // 24 hours
      staleTime: 1000 * 20, // 20 seconds
    },
  },
});
